import React, { useState, useRef } from "react";
import {
  ConfirmationDialog,
  waiverApprovalType,
  waiverStatusLowerCase,
  WaiverType
} from "@toorak/tc-common-fe-sdk";
import {
  Grid,
  Dialog,
  MenuItem,
  IconButton,
  Checkbox,
  TextField,
  Chip
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate, useParams } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  postApproveException,
  // setActionClicks,
  setAskAQuestionClicked,
  setSatisfyExceptionsClicked,
  setWaiverRequestedClicked,
  getViewMoreDetails,
  getWaiverByLoanId
} from "../../stores/ExceptionsResults/ExceptionActions";
import {
  getCompensatingFactor,
  waiverApproval
} from "../../stores/WaiverRequest/WaiverRequest.action";
import { isViewOnly } from "../../utils/formatChecks";
import useOutsideClick from "../../custom-hooks/useOutsideClick";
import { getCookie } from "../../utils/cookies";
import { uuidV4 } from "../../utils/utils";

import {
  ConditionsIconStyles,
  // IconButtonDropdownStyles,
  IconButtonStylesSubmitAction,
  IconButtonStylesSubmitDisable,
  // IconDisabledButtonDropdownStyles
  ConditionsIconDisabledStyles
} from "./DocumentsForm.style";
import { isLATUser } from "../../utils/AccessManagement";
import { isRescindAllowed } from "./WaiverUtils.common";
import { RootState } from "../../stores/rootReducer";
import {
  // setActiveInteractionsArray,
  openRescindSuccessDialog
  // setActiveInteractionsModal
} from "../create-loan.action";
import { getDashboardViewMore } from "../../stores/dashboardSection/dashboard.action";
import { setActionClicks } from "../../stores/ExceptionsResults/ExceptionsReducer";
import { setActiveInteractionsArray } from "../create-loan.reducer";

const icon = <CheckBoxOutlineBlankIcon fontSize="large" />;
const checkedIcon = <CheckBoxIcon fontSize="large" />;

const useStyles = makeStyles({
  autoComplete: {
    marginBottom: "1rem",
    width: "92%",
    "&.Mui-focused *": {
      boxShadow: "none !important",
      border: "none"
    },
    "&.Mui-focused": {
      border: "1px solid rgb(136, 151, 170);",
      borderRadius: 5
    }
  }
});
const CommentsBlock = React.lazy(() =>
  import("../loan-lists/comments-section/components/CommentsBlock").then(
    (module) => ({
      default: module.CommentsBlock
    })
  )
);

const SettingsIconDark = React.lazy(() =>
  import("../Icons").then((module) => ({
    default: module.SettingsIconDark
  }))
);

const ArrowNext = React.lazy(() =>
  import("../Icons").then((module) => ({
    default: module.ArrowNext
  }))
);

const WaiverOneActionButton = React.lazy(() =>
  import("./WaiverOneActionButton").then((module) => ({
    default: module.WaiverOneActionButton
  }))
);

const InfoOnlyTooltip = React.lazy(() =>
  import("../../utils/Tooltip").then((module) => ({
    default: module.InfoOnlyTooltip
  }))
);

export const WaiverActionsButton = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { waiverRebuttal, reOpen, approvedConditionally, approve } =
    waiverApprovalType;
  // const iconButtonOverrideClasses = IconButtonDropdownStyles();
  const conditionsIconClasses = ConditionsIconStyles();
  const iconButtonStylesSubmitAction = IconButtonStylesSubmitAction();
  const iconDisabledButtonDropdownStyles = ConditionsIconDisabledStyles();
  const iconButtonStylesSubmitDisable = IconButtonStylesSubmitDisable();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const { loanType, visibility, type } = useParams<any>() as any;
  const {
    waiverId,
    loanId,
    // backLocation,
    exceptionId,
    waiverResponseType,
    exceptionDetails,
    loanStage,
    exceptionType,
    // waiverRequestedInfo,
    // exceptionWaiverId,
    status,
    statusDisable,
    approvedWaiverLength,
    waiversCount,
    isViewMode,
    waiverApproved,
    customerDetails,
    waiverChat,
    isCarryForwardedWaiver,
    RequestAndTakeAction,
    waiverType,
    deleteWaiver,
    visibilityProp,
    handleWaiverApprovalSuccess,
    showRescind,
    isWithdrawnProp,
    currentLoanStage,
    exceptionIdActInt,
    selectedCompensatingFactors,
    setWaiverResponseType,
    setselectedCompensatingFactors,
    isActioningForSDInquiryByLAT
  } = props;

  const classes = useStyles();
  const [compensatingFactors, setCompensatingFactors] = useState<any>([]);
  const { isWithdrawnLoan } = useSelector<RootState, any>(
    (state) => state.createLoanStore
  );

  const { activeInteractionsModal } = useSelector<RootState, any>(
    (state) => state.createLoanStore
  );

  const isRescindAllowedResp =
    (!isWithdrawnLoan || !isWithdrawnProp) &&
    isRescindAllowed(waiverResponseType, waiverType);
  const waiverActionsOptionsForLAT = RequestAndTakeAction
    ? [
        "Submit and Approve",
        "Submit and Conditionally Approve",
        "Submit and Reject"
      ]
    : isRescindAllowedResp
    ? [
        "Approve Waiver Request",
        "Approve-Conditionally",
        "Reject Waiver Request",
        "Rescind Waiver"
      ]
    : [
        "Approve Waiver Request",
        "Approve-Conditionally",
        "Reject Waiver Request"
      ];
  const { rejected, requested, reRequested, rescind, approved } =
    waiverStatusLowerCase;
  const waiverActionsOptionsForOriginator = isRescindAllowedResp
    ? ["Rescind Waiver", "Delete Waiver"]
    : [];
  // if(waiverResponseType && isRescindAllowedResp){
  //   waiverActionsOptionsForLAT.push("Rescind Waiver")
  // }
  const waiverActionsOptions = isLATUser()
    ? waiverActionsOptionsForLAT
    : waiverActionsOptionsForOriginator;
  const exceptionActionsOptions =
    exceptionDetails && exceptionDetails.visibility === "external"
      ? [
          "Approve Loan Inquiry",
          "Approve-Conditionally",
          "Reject Loan Inquiry",
          "Rescind Loan Inquiry"
        ]
      : [
          "Approve Loan Inquiry",
          "Approve-Conditionally",
          "Reject Loan Inquiry",
          // "Rescind Loan Inquiry",
          "Ask a Question",
          "Request a Waiver",
          "Satisfy Inquiry"
        ];
  const reOpenItem = [`Re-Open ${exceptionId ? "Loan Inquiry" : "Waiver"}`];
  if (!exceptionId && !isLATUser()) {
    reOpenItem.push("Waiver Rebuttal");
  }
  const statusToReOpen =
    status &&
    (status?.toLowerCase() === approved ||
      status?.toLowerCase() === "approved-conditionally" ||
      status?.toLowerCase() === rescind ||
      status?.toLowerCase() === rejected);
  const dropDownActions = !exceptionType
    ? !waiverApproved
      ? waiverActionsOptions
      : reOpenItem
    : statusToReOpen
    ? reOpenItem
    : exceptionActionsOptions;
  const [isMoreActionsDropdownVisible, setIsMoreActionsDropdownVisible] =
    useState(false);
  const [open, setOpen] = React.useState(false);
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [approvalType, setApprovalType] = useState<string>("");

  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, () => {
    if (isMoreActionsDropdownVisible)
      setIsMoreActionsDropdownVisible(!isMoreActionsDropdownVisible);
  });

  const personPartyId: string | any = getCookie("person_id");
  const approveException = (comment?: any) => {
    // handleClose();
    setOpen(false);
    setIsMoreActionsDropdownVisible(!isMoreActionsDropdownVisible);
    const approvalStatus =
      approvalType === approve
        ? "APPROVED"
        : approvalType === approvedConditionally
        ? "APPROVED-CONDITIONALLY"
        : approvalType === reOpen
        ? "REOPENED"
        : approvalType === rescind
        ? "RESCIND"
        : "REJECTED";
    dispatch(
      postApproveException(
        exceptionDetails,
        loanId,
        loanStage,
        exceptionId,
        approvalStatus,
        comment,
        approvalStatus,
        personPartyId
      )
    );
  };

  const openCompensatingFactors = () => {
    if (!compensatingFactors.length) {
      const body = {
        loanType: "",
        loanStage: "",
        userGroup: "",
        userId: ""
      };
      setIsLoading(true);
      getCompensatingFactor(body)
        .then((res: any) => {
          setCompensatingFactors(res.data.sort());
          setIsLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  };

  const approveWaiver = (comment?: any) => {
    // handleClose();
    setOpen(false);
    setIsMoreActionsDropdownVisible(false);
    if (exceptionId) {
      approveException(comment);
      if (activeInteractionsModal) {
        dispatch(setActiveInteractionsArray({ waiverId: exceptionId, loanId }));
      }
      return null;
    }
    waiverApproval({
      waiverId,
      loanId,
      isApproved: !!(
        approvalType === approve || approvalType === approvedConditionally
      ),
      compensatingFactors: selectedCompensatingFactors,
      responseType:
        approvalType === approve
          ? "APPROVED"
          : approvalType === approvedConditionally
          ? "APPROVED-CONDITIONALLY"
          : approvalType === reOpen
          ? "REOPENED"
          : approvalType === waiverRebuttal
          ? "REBUTTAL"
          : approvalType === "Rescind Waiver Comment"
          ? "RESCIND"
          : "REJECTED"
    }).then((resp: any) => {
      if (window.location.href.indexOf("tab=0") > -1) {
        if (resp.data.responseType === "RESCIND") {
          dispatch(openRescindSuccessDialog(true));
        }
        dispatch(
          getDashboardViewMore(
            loanId,
            loanStage,
            visibilityProp,
            exceptionIdActInt || exceptionId,
            "Condition"
          )
        );
      }
      // checking for condition from active interactions page
      if (
        loanStage &&
        window.location.href.indexOf("Condition") > -1 &&
        ["APPROVED", "APPROVED-CONDITIONALLY"].includes(resp.data.responseType)
      ) {
        dispatch(getWaiverByLoanId(loanId, loanStage, waiverId));
      }

      if (window.location.href.indexOf("createLoan") > -1) {
        if (resp.data.responseType === "RESCIND") {
          dispatch(openRescindSuccessDialog(true));
        }
        dispatch(
          getViewMoreDetails(
            loanId,
            loanStage,
            visibilityProp,
            exceptionIdActInt || exceptionId,
            "Condition"
          )
        );
      }

      if (window.location.href.indexOf("view") > -1) {
        handleWaiverApprovalSuccess(resp);
      }
      if (activeInteractionsModal) {
        setTimeout(() => {
          dispatch(setActiveInteractionsArray({ waiverId, loanId }));
        }, 1000);
      }
      // const waiver = {
      //   isApproved: resp.data.isApproved,
      //   responseBy: resp.data.responseBy,
      //   responseDate: resp.data.responseDate,
      //   responseType: resp.data.responseType
      // };
      // dispatch(updateWaiverApprovalStatus(waiverId, waiver, exceptionWaiverId));
      // dispatch(requestedWaierUserName(waiverRequestedInfo));
      // if (loanStage === LoanStage.post) {
      //   dispatch({
      //     type: UPDATE_POLLING_DATA,
      //     payload: {
      //       startPolling: true,
      //       timeInMs: 0
      //     }
      //   });
      // }
      // if (backLocation) {
      //   if (
      //     typeof backLocation === "string" &&
      //     backLocation.includes("/loan/createLoan/")
      //   ) {
      //     // check if guideline tab or not
      //     navigate(backLocation);
      //   } else {
      //     navigate(backLocation);
      //   }
      // }
    });
  };
  const approvalCase = [
    "Submit and Approve",
    "Approve Waiver Request",
    "Approve Loan Inquiry"
  ];
  const condApprovalCases = [
    "Submit and Conditionally Approve",
    "Approve-Conditionally"
  ];
  const reOpenCases = ["Re-Open Loan Inquiry", "Re-Open Waiver"];

  const handleClick = (item: any) => {
    if (
      item === "Ask a Question" ||
      item === "Satisfy Inquiry" ||
      item === "Request a Waiver"
    ) {
      handleActions(item);
    } else {
      // handleOpen();
      if (item === "Delete Waiver") {
        setOpenConfirmBox(true);
        return;
      }
      setOpen(true);
      setApprovalType(
        approvalCase.includes(item)
          ? "Approve"
          : condApprovalCases.includes(item)
          ? "Approve-Conditionally"
          : item === "Waiver Rebuttal"
          ? "Waiver Rebuttal"
          : item === "Rescind Waiver"
          ? "Rescind Waiver Comment"
          : reOpenCases.includes(item)
          ? "Re-Open"
          : item === "Rescind Loan Inquiry"
          ? "Rescind"
          : "Reject"
      );
      if (setWaiverResponseType) {
        setWaiverResponseType(
          approvalCase.includes(item)
            ? "Approve"
            : condApprovalCases.includes(item)
            ? "Approve-Conditionally"
            : item === "Waiver Rebuttal"
            ? "Waiver Rebuttal"
            : item === "Rescind Waiver"
            ? "Rescind Waiver Comment"
            : reOpenCases.includes(item)
            ? "Re-Open"
            : item === "Rescind Loan Inquiry"
            ? "Rescind"
            : "Reject"
        );
      }
      if (isMoreActionsDropdownVisible)
        setIsMoreActionsDropdownVisible(!isMoreActionsDropdownVisible);
      // setTimeout(() => {
      //   dispatch(setActiveInteractionsModal(false, loanId, loanStage));
      // }, [1000]);
    }
  };

  const handleActions = (itemType: any) => {
    const actionID: string = uuidV4();
    if (isMoreActionsDropdownVisible)
      setIsMoreActionsDropdownVisible(!isMoreActionsDropdownVisible);
    setTimeout(() => {
      dispatch(
        setActionClicks({
          type: itemType,
          exceptionId,
          actionId: actionID
        })
      );
      navigate(
        `/loan/create/${loanType}/${loanStage}/${loanId}/${type}/${exceptionId}/${
          exceptionDetails && exceptionDetails.visibility
        }/view`
      );
      if (itemType === "Ask a Question") {
        dispatch(setAskAQuestionClicked(true, exceptionId));
        dispatch(setSatisfyExceptionsClicked(false, exceptionId));
        dispatch(setWaiverRequestedClicked(false, exceptionId));
      } else if (
        itemType === "Satisfy Inquiry" ||
        itemType === "Satisfy Condition"
      ) {
        dispatch(setAskAQuestionClicked(false, exceptionId));
        dispatch(setSatisfyExceptionsClicked(true, exceptionId));
        dispatch(setWaiverRequestedClicked(false, exceptionId));
      } else {
        dispatch(setAskAQuestionClicked(false, exceptionId));
        dispatch(setWaiverRequestedClicked(true, exceptionId));
        dispatch(setSatisfyExceptionsClicked(false, exceptionId));
      }
    });
  };
  const dropDownDisabled = !!(
    isActioningForSDInquiryByLAT ||
    statusDisable ||
    (waiversCount > 0 && approvedWaiverLength === 0) ||
    isViewMode ||
    isWithdrawnLoan ||
    isWithdrawnProp ||
    isViewOnly(loanStage, loanId, currentLoanStage)
  );
  // const handleButtonClick = (onClick: boolean) => {
  //   console.log({onClick});

  //   if (onClick) {
  //     setIsMoreActionsDropdownVisible(!isMoreActionsDropdownVisible);
  //   }
  // };
  const canViewRescindButton = () =>
    (!isWithdrawnLoan || !isWithdrawnProp) &&
    !isViewOnly(loanStage, loanId, currentLoanStage) &&
    waiverType !== WaiverType.evaluationResult &&
    ![rejected, rescind, requested, reRequested].includes(
      waiverResponseType?.toLowerCase()
    );

  return (
    <Grid item style={{ paddingLeft: "0" }}>
      {canViewRescindButton() &&
      !statusDisable &&
      !isLATUser() &&
      isRescindAllowed(waiverResponseType, waiverType) ? (
        <WaiverOneActionButton
          handleClick={handleClick}
          label="Rescind Waiver"
          topic="Rescind Waiver"
        />
      ) : !isRescindAllowedResp &&
        !statusDisable &&
        !isViewOnly(loanStage, loanId, currentLoanStage) &&
        (!isWithdrawnLoan || !isWithdrawnProp) &&
        !isLATUser() &&
        waiverResponseType?.toLowerCase() === rejected ? (
        <WaiverOneActionButton
          handleClick={handleClick}
          label="Waiver Rebuttal"
          topic="Waiver Rebuttal"
        />
      ) : (
        !showRescind && (
          <Grid item>
            <div ref={ref}>
              <InfoOnlyTooltip
                title={
                  isViewMode
                    ? `Actions are disabled because loan is now converted`
                    : isWithdrawnLoan || isWithdrawnProp
                    ? "Actions are disabled because this loan is now withdrawn"
                    : isActioningForSDInquiryByLAT
                    ? `Actions to SD Inquiries should be through ILP`
                    : dropDownDisabled &&
                      waiversCount > 0 &&
                      approvedWaiverLength === 0
                    ? `Actions are disabled because Waiver is Pending on Loan Inquiry`
                    : statusDisable
                    ? `Actions are disabled because ${type} is already ${status}`
                    : `Actions on ${exceptionId ? "Loan Inquiry" : "Waiver"}`
                }
                arrow
                placement="right"
              >
                <span>
                  <IconButton
                    aria-label="actions"
                    component="button"
                    aria-haspopup="true"
                    onClick={() => {
                      // handleButtonClick(!dropDownDisabled);
                      if (
                        !dropDownDisabled ||
                        (!dropDownDisabled &&
                          !isLATUser() &&
                          approvalType === "Reject")
                      ) {
                        setIsMoreActionsDropdownVisible(
                          !isMoreActionsDropdownVisible
                        );
                      }
                    }}
                    style={{
                      background: !RequestAndTakeAction ? "white" : "#5f72e4",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.22)",
                      opacity: dropDownDisabled ? 0.5 : 1
                    }}
                    classes={
                      RequestAndTakeAction
                        ? !dropDownDisabled
                          ? iconButtonStylesSubmitAction
                          : iconButtonStylesSubmitDisable
                        : !dropDownDisabled
                        ? conditionsIconClasses
                        : iconDisabledButtonDropdownStyles
                    }
                    size="large"
                  >
                    {RequestAndTakeAction ? (
                      <ArrowNext />
                    ) : (
                      <SettingsIconDark />
                    )}
                  </IconButton>
                </span>
              </InfoOnlyTooltip>
              {isMoreActionsDropdownVisible && (
                <div
                  style={{
                    borderRadius: 4,
                    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.16)",
                    backgroundColor: "#ffffff",
                    padding: 0,
                    paddingTop: 6,
                    paddingBottom: 6,
                    marginTop: 0,
                    position: "absolute",
                    zIndex: 1,
                    maxHeight: "165px",
                    overflowY: "auto",
                    minWidth: "160px",
                    overflowX: "hidden",
                    right: RequestAndTakeAction ? "auto" : "3px"
                  }}
                >
                  {dropDownActions.map((item) => (
                    <MenuItem
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handleClick(item);
                      }}
                      role="button"
                      // onKeyDown={() => {
                      //   handleClick(item);
                      // }}
                      tabIndex={0}
                      key={item}
                      style={{
                        cursor: !statusDisable ? "pointer" : "default",
                        fontSize: 12,
                        color: "#32325d",
                        // paddingBottom: 8,
                        lineHeight: 2,
                        padding: "6px 10px 8px 10px",
                        whiteSpace: "nowrap"
                        // fontWeight: 600
                      }}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </div>
              )}
            </div>
            <ConfirmationDialog
              onCancel={() => setOpenConfirmBox(false)}
              onConfirm={() => deleteWaiver(true)}
              open={openConfirmBox}
              head="Delete Waiver"
              msg="Are you sure you want to delete the waiver request?"
            />
          </Grid>
        )
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        // onClose={() => handleClose()}setOpen(false);
        aria-labelledby="waiver-approval-modal"
        aria-describedby="waiver-approval-modal-description"
      >
        <div style={{ padding: 20, width: 786, maxWidth: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexGrow: 1,
              borderBottom: "solid 2px #f2f2f2",
              paddingBottom: "20px",
              alignItems: "center"
            }}
          >
            <div style={{ fontSize: 14, fontWeight: 600, color: "#32325d" }}>
              {approvalType}{" "}
              {!exceptionId
                ? ![
                    waiverApprovalType.waiverRebuttal,
                    "Rescind Waiver Comment"
                  ].includes(approvalType)
                  ? "Waiver Request"
                  : ""
                : approvalType !== ""
                ? "Loan Inquiry"
                : ""}
            </div>
            <CloseIcon
              htmlColor="#414169"
              style={{ width: 16, height: 16, cursor: "pointer" }}
              onClick={() => setOpen(false)}
            />
          </div>
          <div
            style={{
              fontSize: 12,
              lineHeight: 1.5,
              color: "#32325d",
              marginTop: 20
              // fontWeight: 600
            }}
          >
            {["Approve", "Approve-Conditionally"].includes(approvalType) && (
              <>
                <Grid
                  style={{
                    textAlign: "left",
                    fontSize: "12px !important",
                    fontWeight: 600,
                    color: "#8897aa",
                    lineHeight: 1.5,
                    paddingBottom: 5
                  }}
                >
                  Compensating Factors (Min. 2)
                </Grid>
                <Autocomplete
                  multiple
                  id="asynchronous-demo"
                  disableClearable
                  className={classes.autoComplete}
                  onOpen={() => {
                    openCompensatingFactors();
                  }}
                  getOptionLabel={(option: any) => option ?? ""}
                  disableCloseOnSelect
                  renderTags={(value, getTagProps) => {
                    setselectedCompensatingFactors(value);
                    return value.map((option, index) => (
                      <Chip
                        style={{
                          background: "#11CEEF",
                          color: "#fff",
                          textTransform: "uppercase",
                          height: 20,
                          border: "none",
                          borderRadius: 6,
                          margin: 0,
                          marginLeft: 8
                        }}
                        variant="outlined"
                        label={option}
                        deleteIcon={<CloseIcon style={{ height: 16 }} />}
                        {...getTagProps({ index })}
                      />
                    ));
                  }}
                  loading={isLoading}
                  options={compensatingFactors}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select"
                    />
                  )}
                />
              </>
            )}
            <CommentsBlock
              selectedCompensatingFactors={selectedCompensatingFactors}
              hostId={waiverId}
              customerDetails={customerDetails}
              waiverChat={waiverChat}
              hostType={exceptionId && "waiver"}
              loanId={loanId}
              loanStage={loanStage}
              hostName="waiver"
              approvalType={approvalType}
              RequestAndTakeAction={RequestAndTakeAction}
              // callBack={callBack}
              // eslint-disable-next-line react/jsx-boolean-value
              approvalComment={true}
              onApproval={approveWaiver}
              isCarryForwardedWaiver={isCarryForwardedWaiver}
              visibility={exceptionDetails?.visibility || visibility}
              currentLoanStage={currentLoanStage}
              showSenderAvatar
            />
          </div>
        </div>
      </Dialog>
    </Grid>
  );
};
